window.addEventListener("load", function () {
  // Select all property options
  var propertyOptions = document.querySelectorAll(".pplr-swatch-element");

  // Add click event listener to each property option
  propertyOptions.forEach(function (option) {
    option.addEventListener("click", function () {
      
      // Get the value of data-val attribute
      var selectedOption = this.getAttribute("data-val");

      // Dispacth event for mobile slides
      document.dispatchEvent(
        new CustomEvent("propertyClick", { detail: selectedOption })
      );

      // Find all images within the gallery
      var images = document.querySelectorAll(".product__media-item img");

      // Iterate through each image
      images.forEach(function (image) {
        // If alt tag matches the selected option, add is-active class
        if (image.alt === selectedOption) {
          // Remove is-active class from all images
          document
            .querySelectorAll(".product__media-item")
            .forEach(function (item) {
              item.classList.remove("is-active");
            });
          // Add is-active class to the closest .product__media-item element
          image.closest(".product__media-item").classList.add("is-active");
        }
      });

      // Iterate through thumbnails to activate current selection
      var thumbnails = document.querySelectorAll("button.thumbnail");
      thumbnails.forEach(function (thumbnail) {
        let thumbImg = thumbnail.querySelector("img");
        if (thumbImg.alt === selectedOption) {
          thumbnail.setAttribute("aria-current", "");
        } else {
          thumbnail.removeAttribute("aria-current");
        }
      });
    });
  });
});
